import { useI18n } from '../i18n/I18nProvider'

function Privacy() {
  const { t } = useI18n()
  return (
    <div className="container mx-auto px-4 py-12">
      <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-lg p-8">
        <h1 className="text-4xl font-bold text-green-800 mb-8">
          {t('privacy.title')}
        </h1>

        <div className="prose prose-green max-w-none space-y-6 text-gray-700">
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('privacy.dataCollection.title')}</h2>
            <p>
              {t('privacy.dataCollection.intro')}
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>{t('privacy.dataCollection.email')}</li>
              <li>{t('privacy.dataCollection.gameData')}</li>
              <li>{t('privacy.dataCollection.payment')}</li>
              <li>{t('privacy.dataCollection.analytics')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('privacy.dataUsage.title')}</h2>
            <p>
              {t('privacy.dataUsage.intro')}
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>{t('privacy.dataUsage.provideService')}</li>
              <li>{t('privacy.dataUsage.manageAccount')}</li>
              <li>{t('privacy.dataUsage.communication')}</li>
              <li>{t('privacy.dataUsage.analytics')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('privacy.dataSharing.title')}</h2>
            <p>
              {t('privacy.dataSharing.intro')}
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>{t('privacy.dataSharing.stripe')}</li>
              <li>{t('privacy.dataSharing.supabase')}</li>
              <li>{t('privacy.dataSharing.legal')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('privacy.security.title')}</h2>
            <p>
              {t('privacy.security.content')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('privacy.cookies.title')}</h2>
            <p>
              {t('privacy.cookies.content')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('privacy.gdpr.title')}</h2>
            <p>
              {t('privacy.gdpr.intro')}
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>{t('privacy.gdpr.access')}</li>
              <li>{t('privacy.gdpr.rectification')}</li>
              <li>{t('privacy.gdpr.erasure')}</li>
              <li>{t('privacy.gdpr.portability')}</li>
              <li>{t('privacy.gdpr.objection')}</li>
            </ul>
            <p className="mt-4">
              {t('privacy.gdpr.contact')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('privacy.dataRetention.title')}</h2>
            <p>
              {t('privacy.dataRetention.content')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('privacy.modifications.title')}</h2>
            <p>
              {t('privacy.modifications.content')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('privacy.contact.title')}</h2>
            <p>
              {t('privacy.contact.content')}
            </p>
          </section>

          <p className="text-sm text-gray-500 mt-8">
            {t('privacy.lastUpdated', { date: new Date().toLocaleDateString(t('privacy.localeCode') || 'fr-FR') })}
          </p>
        </div>
      </div>
    </div>
  )
}

export default Privacy
